(function() {
  var STORAGE_KEY = 'amour-swatch-state';
  var STORAGE_TTL = 30 * 60 * 1000;
  var groupsPromise;
  var normalizedChartMap;
  var kiwiModalScrollY = null;
  var kiwiModalWasOpen = false;
  var kiwiPointerDownScrollY = null;
  var kiwiCustomModalState = null;
  var sizeChartConfigCache = null;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getCurrentHandle() {
    var configuredHandle = window.amourSwatchConfig && window.amourSwatchConfig.productHandle;
    var path = window.location.pathname || '';
    var handle = path.replace(/^\/+|\/+$/g, '').split('/products/').pop().split('/')[0];
    return decodeURIComponent(configuredHandle || handle || '');
  }

  function normalizeHandle(handle) {
    return decodeURIComponent(String(handle || ''))
      .trim()
      .toLowerCase()
      .normalize('NFKC');
  }

  function getForm() {
    return document.getElementById('add-to-cart-form') || document.querySelector('form[action="/cart/add"]');
  }

  function fetchGroups() {
    if (groupsPromise) {
      return groupsPromise;
    }

    if (!window.amourSwatchConfig || !window.amourSwatchConfig.groupDataUrl) {
      return Promise.resolve(null);
    }

    groupsPromise = fetch(window.amourSwatchConfig.groupDataUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Unable to load swatch groups');
        }
        return response.json();
      })
      .then(function(data) {
        normalizedChartMap = {};

        if (data && data.product_groups_chart) {
          Object.keys(data.product_groups_chart).forEach(function(handle) {
            normalizedChartMap[normalizeHandle(handle)] = data.product_groups_chart[handle];
          });
        }

        return data;
      })
      .catch(function() {
        return null;
      });

    return groupsPromise;
  }

  function getGroupImage(optionName, optionValue) {
    var images = (window.amourSwatchConfig && window.amourSwatchConfig.images) || {};
    var optionNameKey = normalize(optionName);
    var optionValueKey = normalize(optionValue);

    if (optionNameKey === 'gemstone') {
      if (optionValueKey.indexOf('moissanite') !== -1) {
        return images.gemstoneBrilliantMoissanite || '';
      }
      if (optionValueKey.indexOf('lab') !== -1) {
        return images.gemstoneLabDiamond || '';
      }
    }

    return '';
  }

  function collectSelectionState(form, mode) {
    var selections = {};

    form.querySelectorAll('#product-variants .swatch[data-option-name]').forEach(function(swatch) {
      var optionName = swatch.getAttribute('data-option-name');
      var sizeSelect = swatch.querySelector('[data-size-select]');
      var checkedRadio = swatch.querySelector('input[type="radio"]:checked');

      if (sizeSelect && sizeSelect.value) {
        selections[optionName] = sizeSelect.value;
        return;
      }

      if (checkedRadio) {
        selections[optionName] = checkedRadio.value;
      }
    });

    return {
      handle: getCurrentHandle(),
      savedAt: Date.now(),
      mode: mode || 'selection',
      selections: selections
    };
  }

  function saveSelectionState(form, mode) {
    if (!form) {
      return;
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(collectSelectionState(form, mode)));
    } catch (error) {
      return;
    }
  }

  function getSelectionState() {
    try {
      var rawState = sessionStorage.getItem(STORAGE_KEY);

      if (!rawState) {
        return null;
      }

      var state = JSON.parse(rawState);

      if (!state.savedAt || Date.now() - state.savedAt > STORAGE_TTL) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return state;
    } catch (error) {
      return null;
    }
  }

  function syncSizeSelects(root) {
    var scope = root || document;

    scope.querySelectorAll('.swatch.amour-swatch--size').forEach(function(swatch) {
      var select = swatch.querySelector('[data-size-select]');
      var radios = Array.prototype.slice.call(swatch.querySelectorAll('.swatch-element input[type="radio"]'));
      var checkedRadio = swatch.querySelector('input[type="radio"]:checked');

      if (!select || !radios.length) {
        return;
      }

      select.innerHTML = '<option value="">SELECT THE RING SIZE</option>';

      radios.forEach(function(radio) {
        var option = document.createElement('option');
        option.value = radio.value;
        option.textContent = radio.value;
        option.disabled = radio.disabled;
        select.appendChild(option);
      });

      if (checkedRadio) {
        select.value = checkedRadio.value;
      }
    });
  }

  function applySavedSelections(form) {
    var state = getSelectionState();

    if (!state || !state.selections || state.mode !== 'linked-navigation') {
      return;
    }

    var swatches = Array.prototype.slice.call(form.querySelectorAll('#product-variants .swatch[data-option-name]'));
    var delay = 0;

    swatches.forEach(function(swatch) {
      var optionName = swatch.getAttribute('data-option-name');
      var desiredValue = state.selections[optionName];

      if (!desiredValue) {
        return;
      }

      window.setTimeout(function() {
        var radio = Array.prototype.slice.call(swatch.querySelectorAll('input[type="radio"]')).find(function(item) {
          return item.value === desiredValue && !item.disabled;
        });

        if (!radio) {
          return;
        }

        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }, delay);

      delay += 75;
    });

    sessionStorage.removeItem(STORAGE_KEY);
  }

  function hideStandaloneSizeChart(form) {
    var productShop;
    if (!form) {
      return;
    }

    var hasInlineSizeChart = form.querySelector('.amour-size-chart-inline');
    var standaloneSizeChart = form.querySelector('.amour-size-chart-standalone');

    productShop = form.closest('.product-shop');

    if (!standaloneSizeChart && productShop) {
      standaloneSizeChart = productShop.querySelector('.amour-size-chart-standalone');
    }

    if (hasInlineSizeChart && standaloneSizeChart) {
      standaloneSizeChart.classList.add('is-hidden');
    }
  }

  function rememberKiwiScrollPosition(scrollY) {
    if (typeof scrollY === 'number') {
      kiwiModalScrollY = scrollY;
    }
  }

  function restoreKiwiScrollPosition() {
    var targetY = kiwiModalScrollY;

    if (typeof targetY !== 'number') {
      return;
    }

    kiwiModalScrollY = null;

    window.requestAnimationFrame(function() {
      window.scrollTo(0, targetY);

      window.requestAnimationFrame(function() {
        if (Math.abs(window.scrollY - targetY) > 2) {
          window.scrollTo(0, targetY);
        }
      });
    });
  }

  function getSizeChartConfig() {
    var configNode;

    if (sizeChartConfigCache) {
      return sizeChartConfigCache;
    }

    if (window.amourSizeChartConfig) {
      sizeChartConfigCache = window.amourSizeChartConfig;
      return sizeChartConfigCache;
    }

    configNode = document.querySelector('[data-amour-size-chart-config]');

    if (!configNode) {
      return null;
    }

    try {
      sizeChartConfigCache = JSON.parse(configNode.textContent || '');
      window.amourSizeChartConfig = sizeChartConfigCache;
      return sizeChartConfigCache;
    } catch (error) {
      return null;
    }
  }

  function isCountrySupportedByChart(config, country) {
    return !!getCountryOption(config, country);
  }

  function getCountryCodeFromLocale(locale) {
    var match;

    if (!locale) {
      return '';
    }

    try {
      if (window.Intl && typeof window.Intl.Locale === 'function') {
        return (new window.Intl.Locale(locale).region || '').toUpperCase();
      }
    } catch (error) {
      // Fall back to regex parsing below.
    }

    match = String(locale).match(/[-_](\w{2})\b/);
    return match ? match[1].toUpperCase() : '';
  }

  function mapCountryCodeToChartCountry(countryCode) {
    switch (String(countryCode || '').trim().toUpperCase()) {
      case 'AT':
        return 'AT';
      case 'BE':
        return 'BE';
      case 'DK':
        return 'DK';
      case 'FI':
        return 'FI';
      case 'FR':
        return 'FR';
      case 'IE':
        return 'IE';
      case 'IT':
        return 'IT';
      case 'NL':
        return 'NL';
      case 'NO':
        return 'NO';
      case 'PT':
        return 'PT';
      case 'ES':
        return 'ES';
      case 'SE':
        return 'SE';
      case 'CH':
        return 'CH';
      case 'GB':
      case 'UK':
        return 'UK';
      case 'US':
      case 'CA':
        return 'US';
      default:
        return null;
    }
  }

  function detectSizeChartCountry(config) {
    var candidates = [];
    var fallbackLocale;

    try {
      candidates.push(localStorage.getItem('edt_country_code'));
    } catch (error) {
      // Ignore localStorage access errors.
    }

    if (window.Shopify && window.Shopify.country) {
      candidates.push(window.Shopify.country);
    }

    if (typeof window.geoplugin_countryCode === 'function') {
      candidates.push(window.geoplugin_countryCode());
    }

    if (navigator.languages && navigator.languages.length) {
      navigator.languages.forEach(function(locale) {
        candidates.push(getCountryCodeFromLocale(locale));
      });
    }

    if (navigator.language) {
      candidates.push(getCountryCodeFromLocale(navigator.language));
    }

    try {
      fallbackLocale = window.Intl && window.Intl.DateTimeFormat ? window.Intl.DateTimeFormat().resolvedOptions().locale : '';
    } catch (error) {
      fallbackLocale = '';
    }

    if (fallbackLocale) {
      candidates.push(getCountryCodeFromLocale(fallbackLocale));
    }

    for (var index = 0; index < candidates.length; index += 1) {
      var chartCountry = mapCountryCodeToChartCountry(candidates[index]);

      if (chartCountry && isCountrySupportedByChart(config, chartCountry)) {
        return chartCountry;
      }
    }

    return null;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function ensureKiwiCustomModalStyles() {
    return;
  }

  function buildSizeChartRowsMarkup(rows, country) {
    return rows.map(function(row) {
      var localizedValue = row.sizes[country] || row.sizes[row.defaultCountry] || '';

      return '' +
        '<tr>' +
          '<th scope="row">' + escapeHtml(row.eu) + '</th>' +
          '<td>' + escapeHtml(localizedValue) + '</td>' +
          '<td>' + escapeHtml(row.diameter) + '</td>' +
        '</tr>';
    }).join('');
  }

  function syncSizeChartScrollState(modalState) {
    var wrap;
    var hasOverflow;
    var atTop;
    var atBottom;

    if (!modalState || !modalState.content) {
      return;
    }

    wrap = modalState.content.querySelector('[data-size-chart-scroll-wrap]');

    if (!wrap) {
      return;
    }

    hasOverflow = wrap.scrollHeight - wrap.clientHeight > 8;
    atTop = wrap.scrollTop <= 8;
    atBottom = wrap.scrollTop + wrap.clientHeight >= wrap.scrollHeight - 8;

    wrap.setAttribute('data-scrollable', hasOverflow ? 'true' : 'false');
    wrap.setAttribute('data-at-top', atTop ? 'true' : 'false');
    wrap.setAttribute('data-at-bottom', atBottom ? 'true' : 'false');
  }

  function getCountryOption(config, country) {
    if (!config || !config.countries) {
      return null;
    }

    return config.countries.find(function(option) {
      return option.value === country;
    }) || null;
  }

  function buildSizeChartHeaderMarkup(config, subtitleMarkup) {
    var logoMarkup = '';
    var titleIconMarkup = '';

    if (config.logo && config.logo.src) {
      logoMarkup = '' +
        '<div class="amour-size-chart-modal__logo">' +
          '<img src="' + escapeHtml(config.logo.src) + '" alt="' + escapeHtml(config.logo.alt || '') + '" loading="lazy">' +
        '</div>';
    } else if (config.brandText) {
      logoMarkup = '<div class="amour-size-chart-modal__brand-text">' + escapeHtml(config.brandText) + '</div>';
    }

    if (config.titleIcon) {
      titleIconMarkup = '' +
        '<span class="amour-size-chart-modal__title-icon" aria-hidden="true">' +
          '<img src="' + escapeHtml(config.titleIcon) + '" alt="" loading="lazy">' +
        '</span>';
    }

    return '' +
      '<div class="amour-size-chart-modal__header">' +
        logoMarkup +
        '<div class="amour-size-chart-modal__heading">' +
          '<div class="amour-size-chart-modal__title-row">' +
            titleIconMarkup +
            '<h3 class="amour-size-chart-modal__title">' + escapeHtml(config.title) + '</h3>' +
          '</div>' +
          subtitleMarkup +
        '</div>' +
      '</div>';
  }

  function buildSizeChartModalMarkup(config, country) {
    var subtitleMarkup = '';
    var selectOptionsMarkup;
    var selectedCountryOption;
    var selectedCountryHeading;
    var selectedCountryLabel;
    var customOrderNoteMarkup = '';

    if (config.subtitle) {
      subtitleMarkup = '<p class="amour-size-chart-modal__subtitle">' + escapeHtml(config.subtitle) + '</p>';
    }

    selectOptionsMarkup = config.countries.map(function(option) {
      var selected = option.value === country ? ' selected' : '';
      return '<option value="' + escapeHtml(option.value) + '"' + selected + '>' + escapeHtml(option.label) + '</option>';
    }).join('');
    selectedCountryOption = getCountryOption(config, country) || {};
    selectedCountryHeading = selectedCountryOption.shortLabel || selectedCountryOption.value || country;
    selectedCountryLabel = selectedCountryOption.label || country;

    if (config.customOrderNote) {
      customOrderNoteMarkup = '<div class="amour-size-chart-modal__note">' + escapeHtml(config.customOrderNote) + '</div>';
    }

    return '' +
      '<div class="amour-size-chart-modal__inner">' +
        buildSizeChartHeaderMarkup(config, subtitleMarkup) +
        '<div class="amour-size-chart-modal__section">' +
          '<div class="amour-size-chart-modal__section-bar">' +
            '<div class="amour-size-chart-modal__section-title">' + escapeHtml(config.tableHeader) + '</div>' +
            '<label class="amour-size-chart-modal__country">' +
              '<span>Country</span>' +
              '<select data-size-chart-country>' + selectOptionsMarkup + '</select>' +
            '</label>' +
          '</div>' +
          '<div class="amour-size-chart-modal__selected-country">Showing sizes for <strong data-size-chart-country-label>' + escapeHtml(selectedCountryLabel) + '</strong></div>' +
          '<div class="amour-size-chart-modal__table-wrap" data-size-chart-scroll-wrap data-scrollable="false" data-at-top="true" data-at-bottom="false">' +
            '<table class="amour-size-chart-modal__table">' +
              '<thead>' +
                '<tr>' +
                  '<th scope="col">EU SIZE</th>' +
                  '<th scope="col" data-size-chart-country-heading>' + escapeHtml(selectedCountryHeading) + '</th>' +
                  '<th scope="col">DIAMETER</th>' +
                '</tr>' +
              '</thead>' +
              '<tbody data-size-chart-rows>' + buildSizeChartRowsMarkup(config.rows, country) + '</tbody>' +
            '</table>' +
          '</div>' +
          customOrderNoteMarkup +
        '</div>' +
      '</div>';
  }

  function updateSizeChartCountry(country) {
    var config = getSizeChartConfig();
    var modalState = ensureKiwiCustomModal();
    var countryOption;
    var heading;
    var countryLabel;
    var rowsContainer;

    if (!config || !modalState) {
      return;
    }

    countryOption = getCountryOption(config, country) || {};
    heading = modalState.content.querySelector('[data-size-chart-country-heading]');
    countryLabel = modalState.content.querySelector('[data-size-chart-country-label]');
    rowsContainer = modalState.content.querySelector('[data-size-chart-rows]');

    if (heading) {
      heading.textContent = countryOption.shortLabel || countryOption.value || country;
    }

    if (countryLabel) {
      countryLabel.textContent = countryOption.label || country;
    }

    if (rowsContainer) {
      rowsContainer.innerHTML = buildSizeChartRowsMarkup(config.rows, country);
    }

    modalState.country = country;
    syncSizeChartScrollState(modalState);
  }

  function ensureKiwiCustomModal() {
    if (kiwiCustomModalState) {
      return kiwiCustomModalState;
    }

    ensureKiwiCustomModalStyles();

    var overlay = document.createElement('div');
    var dialog = document.createElement('div');
    var closeButton = document.createElement('button');
    var content = document.createElement('div');

    overlay.className = 'amour-kiwi-modal-overlay';
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');

    dialog.className = 'amour-size-chart-modal';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');

    closeButton.type = 'button';
    closeButton.className = 'amour-size-chart-modal__close';
    closeButton.setAttribute('aria-label', 'Close size chart');
    closeButton.textContent = '\u00d7';

    content.className = 'amour-size-chart-modal__content';

    dialog.appendChild(closeButton);
    dialog.appendChild(content);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    kiwiCustomModalState = {
      overlay: overlay,
      content: content,
      closeButton: closeButton,
      bodyOverflow: '',
      scrollY: 0,
      country: null,
      scrollWrap: null,
      returnFocus: null
    };

    function closeCustomModal() {
      if (!kiwiCustomModalState || kiwiCustomModalState.overlay.hidden) {
        return;
      }

      var returnFocus = kiwiCustomModalState.returnFocus;

      kiwiCustomModalState.overlay.hidden = true;
      kiwiCustomModalState.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = kiwiCustomModalState.bodyOverflow;
      restoreKiwiScrollPosition();

      if (returnFocus && document.documentElement.contains(returnFocus)) {
        window.requestAnimationFrame(function() {
          returnFocus.focus({ preventScroll: true });
        });
      }
    }

    closeButton.addEventListener('click', closeCustomModal);
    overlay.addEventListener('click', function(event) {
      if (event.target === overlay) {
        closeCustomModal();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeCustomModal();
      }
    });

    kiwiCustomModalState.close = closeCustomModal;
    return kiwiCustomModalState;
  }

  function openKiwiCustomModal(trigger) {
    var config = getSizeChartConfig();
    var modalState;
    var selectedCountry;
    var countrySelect;

    if (!config || !config.rows || !config.rows.length) {
      return false;
    }

    modalState = ensureKiwiCustomModal();
    modalState.bodyOverflow = document.body.style.overflow;
    modalState.returnFocus = trigger || document.activeElement;
    selectedCountry = modalState.country || detectSizeChartCountry(config) || config.defaultCountry || (config.countries[0] && config.countries[0].value) || 'UK';
    rememberKiwiScrollPosition(window.scrollY);
    modalState.content.innerHTML = buildSizeChartModalMarkup(config, selectedCountry);
    modalState.overlay.hidden = false;
    modalState.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    modalState.country = selectedCountry;
    modalState.scrollWrap = modalState.content.querySelector('[data-size-chart-scroll-wrap]');

    countrySelect = modalState.content.querySelector('[data-size-chart-country]');

    if (countrySelect) {
      countrySelect.addEventListener('change', function(event) {
        updateSizeChartCountry(event.target.value);
      });
    }

    if (modalState.scrollWrap) {
      modalState.scrollWrap.addEventListener('scroll', function() {
        syncSizeChartScrollState(modalState);
      }, { passive: true });
      syncSizeChartScrollState(modalState);
    }

    window.requestAnimationFrame(function() {
      modalState.closeButton.focus({ preventScroll: true });
    });

    return true;
  }

  function handleKiwiTriggerPointerDown(event) {
    var kiwiTrigger = event.target.closest && event.target.closest('[data-size-chart-trigger]');

    if (!kiwiTrigger) {
      return;
    }

    kiwiPointerDownScrollY = window.scrollY;
    rememberKiwiScrollPosition(kiwiPointerDownScrollY);
  }

  function handleKiwiTriggerClickCapture(event) {
    var kiwiTrigger = event.target.closest && event.target.closest('[data-size-chart-trigger]');

    if (!kiwiTrigger) {
      return;
    }

    if (kiwiTrigger.closest('[data-ovale-pdp]')) {
      return;
    }

    if (openKiwiCustomModal(kiwiTrigger)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      kiwiPointerDownScrollY = null;
      return;
    }
  }

  function isVisible(node) {
    if (!node || !(node instanceof HTMLElement)) {
      return false;
    }

    if (node.hidden || node.closest('[hidden], .is-hidden, .amour-kiwi-hidden')) {
      return false;
    }

    var style = window.getComputedStyle(node);

    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }

    return node.getClientRects().length > 0;
  }

  function isKiwiModalOpen() {
    var backdrop = document.querySelector('.ks-modal-backdrop');
    var modal = document.querySelector('.kiwi-sizing-modal');

    if (backdrop && !backdrop.classList.contains('hide')) {
      return true;
    }

    if (!modal || !isVisible(modal)) {
      return false;
    }

    return modal.classList.contains('kiwi-sizing-modal-visible') || window.getComputedStyle(modal).display !== 'none';
  }

  function syncKiwiModalState() {
    var modalOpen = isKiwiModalOpen();

    if (modalOpen) {
      kiwiModalWasOpen = true;
      return;
    }

    if (kiwiModalWasOpen) {
      kiwiModalWasOpen = false;
      restoreKiwiScrollPosition();
    }
  }

  function bindKiwiModalObserver() {
    if (document.documentElement.dataset.amourKiwiModalObserved === 'true') {
      return;
    }

    document.documentElement.dataset.amourKiwiModalObserved = 'true';

    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function() {
        syncKiwiModalState();
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('pointerdown', handleKiwiTriggerPointerDown, true);
    document.addEventListener('mousedown', handleKiwiTriggerPointerDown, true);
    document.addEventListener('touchstart', handleKiwiTriggerPointerDown, true);
    document.addEventListener('click', handleKiwiTriggerClickCapture, true);
  }

  function getKiwiTriggers(scope) {
    if (!scope) {
      return [];
    }

    return Array.prototype.slice.call(
      scope.querySelectorAll('a, button, span.ks-chart-modal-link, span.sizing-chart-modal-link, [role="button"], [data-ks-modal-link], [data-ks-open-modal]')
    ).filter(function(node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var ariaLabel = (node.getAttribute('aria-label') || '').trim().toLowerCase();
      var classes = (node.className || '').toString().toLowerCase();
      var id = (node.id || '').toLowerCase();
      var href = (node.getAttribute('href') || '').toLowerCase();
      var descriptor = [text, ariaLabel, classes, id, href].join(' ');

      return /size\s*chart|size\s*guide|sizing|kiwi|ks-/.test(descriptor);
    });
  }

  function getInlineKiwiTrigger(form) {
    var sizeHeader;
    var inlineScopes;
    var inlineTrigger = null;

    if (!form) {
      return null;
    }

    sizeHeader = form.querySelector('.swatch.amour-swatch--size .header');

    if (!sizeHeader) {
      return null;
    }

    inlineScopes = Array.prototype.slice.call(
      sizeHeader.querySelectorAll(
        '.amour-kiwi-target, .shopify-app-block, .shopify-block.shopify-app-block, .ks-container-app-block'
      )
    );

    inlineScopes.some(function(scope) {
      inlineTrigger = getKiwiTriggers(scope).find(function(node) {
        return !node.matches('[data-kiwi-proxy]') && isVisible(node);
      }) || null;

      return Boolean(inlineTrigger);
    });

    return inlineTrigger;
  }

  function hideDuplicateKiwiBlocks(form) {
    var sizeHeader;

    if (!form) {
      return;
    }

    sizeHeader = form.querySelector('.swatch.amour-swatch--size .header');

    document.querySelectorAll('.shopify-app-block, .shopify-block.shopify-app-block, .ks-container-app-block').forEach(function(node) {
      var block = node.closest('.shopify-app-block, .shopify-block.shopify-app-block') || node;
      var text = (block.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var looksLikeKiwi = /size chart/.test(text) || block.querySelector('[id*="kiwi" i], [class*="kiwi" i], [class*="ks-" i]');

      if (!looksLikeKiwi) {
        return;
      }

      if (sizeHeader && sizeHeader.contains(block)) {
        block.classList.remove('amour-kiwi-hidden');
        return;
      }

      block.classList.add('amour-kiwi-hidden');
    });
  }

  function moveKiwiSizeChart(form) {
    var sizeHeader;
    var kiwiBlocks;
    var kiwiContainers;
    var kiwiBlock;
    var inlineFallback;
    var standaloneFallback;
    var kiwiInlineTriggers;

    if (!form) {
      return;
    }

    sizeHeader = form.querySelector('.swatch.amour-swatch--size .header');

    if (!sizeHeader) {
      return;
    }

    kiwiBlocks = Array.prototype.slice.call(
      document.querySelectorAll('.shopify-app-block[id*="kiwi_size_chart_recommender"], .shopify-block.shopify-app-block[id*="kiwi_size_chart_recommender"]')
    );
    kiwiContainers = Array.prototype.slice.call(document.querySelectorAll('.ks-container-app-block'));
    kiwiBlock = kiwiBlocks[0] || null;

    if (!kiwiBlock && kiwiContainers.length) {
      kiwiBlock = kiwiContainers[0].closest('.shopify-app-block, .shopify-block.shopify-app-block') || kiwiContainers[0];
    }

    if (!kiwiBlock) {
      return;
    }

    if (!sizeHeader.contains(kiwiBlock)) {
      kiwiBlock.classList.add('amour-kiwi-inline-block');
      sizeHeader.insertBefore(kiwiBlock, sizeHeader.querySelector('[data-option-select]'));
    }

    Array.prototype.slice.call(kiwiBlock.querySelectorAll('.ks-chart-container')).slice(1).forEach(function(duplicateContainer) {
      duplicateContainer.remove();
    });

    Array.prototype.slice.call(kiwiBlock.querySelectorAll('.ks-calculator-container')).slice(1).forEach(function(duplicateCalculator) {
      duplicateCalculator.remove();
    });

    inlineFallback = form.querySelector('.amour-size-chart-inline');
    standaloneFallback = form.querySelector('.amour-size-chart-standalone');
    kiwiInlineTriggers = getKiwiTriggers(kiwiBlock);

    if (inlineFallback) {
      inlineFallback.classList.toggle('is-hidden', kiwiInlineTriggers.length > 0);
    }

    if (standaloneFallback) {
      standaloneFallback.classList.add('is-hidden');
    }

    kiwiBlocks.slice(1).forEach(function(duplicateBlock) {
      duplicateBlock.classList.add('amour-kiwi-hidden');
    });

    kiwiContainers.forEach(function(container) {
      var containerBlock = container.closest('.shopify-app-block, .shopify-block.shopify-app-block') || container;

      if (containerBlock === kiwiBlock || sizeHeader.contains(containerBlock)) {
        return;
      }

      containerBlock.classList.add('amour-kiwi-hidden');
    });

    hideDuplicateKiwiBlocks(form);
  }

  function watchKiwiSizeChart(form) {
    if (!form || form.dataset.amourKiwiObserved === 'true') {
      return;
    }

    form.dataset.amourKiwiObserved = 'true';

    moveKiwiSizeChart(form);

    if (typeof MutationObserver !== 'function') {
      return;
    }

    var observer = new MutationObserver(function() {
      moveKiwiSizeChart(form);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function createLinkedOption(group, optionValue, currentHandle) {
    var targetHandle = optionValue.handle;
    var isActive = normalizeHandle(targetHandle) === normalizeHandle(currentHandle);
    var optionImage = getGroupImage(group.option_name, optionValue.option_value);
    var option = document.createElement('a');

    option.className = 'amour-linked-option' + (isActive ? ' is-active' : '');
    option.href = '/products/' + encodeURIComponent(targetHandle);
    option.setAttribute('data-linked-handle', targetHandle);
    option.setAttribute('data-option-value', optionValue.option_value);

    if (optionImage) {
      option.insertAdjacentHTML(
        'beforeend',
        '<span class="amour-swatch__media"><img src="' + optionImage + '" alt="' + optionValue.option_value.replace(/"/g, '&quot;') + '" loading="lazy" width="40" height="40"></span>'
      );
    }

    option.insertAdjacentHTML('beforeend', '<span class="amour-swatch__text">' + optionValue.option_value + '</span>');

    return option;
  }

  function buildLinkedSwatches(form, data) {
    var productVariants = form.querySelector('#product-variants');
    var firstSwatch = productVariants && productVariants.querySelector('.swatch');
    var currentHandle = getCurrentHandle();
    var groupIndexes = normalizedChartMap ? normalizedChartMap[normalizeHandle(currentHandle)] : null;

    if (!productVariants || !firstSwatch || !groupIndexes || !groupIndexes.length) {
      return;
    }

    productVariants.querySelectorAll('.amour-linked-swatch').forEach(function(groupNode) {
      groupNode.remove();
    });

    groupIndexes.forEach(function(groupIndex) {
      var group = data.product_groups[groupIndex];
      var visibleValues;
      var linkedClass;
      var linkedSwatch;
      var linkedOptions;

      if (!group || !group.option_values || !group.option_values.length) {
        return;
      }

      visibleValues = group.option_values.filter(function(optionValue) {
        return optionValue.published;
      });

      if (!visibleValues.length) {
        return;
      }

      linkedClass = normalize(group.option_name) === 'gemstone' ? ' amour-linked-swatch--gemstone' : ' amour-linked-swatch--text';
      linkedSwatch = document.createElement('div');
      linkedSwatch.className = 'swatch amour-linked-swatch' + linkedClass;
      linkedSwatch.setAttribute('data-option-name', group.option_name);
      linkedSwatch.innerHTML = '<div class="header"><span class="amour-swatch__title">' + group.option_name + '</span></div><div class="amour-linked-options"></div>';

      linkedOptions = linkedSwatch.querySelector('.amour-linked-options');

      visibleValues.forEach(function(optionValue) {
        linkedOptions.appendChild(createLinkedOption(group, optionValue, currentHandle));
      });

      productVariants.insertBefore(linkedSwatch, firstSwatch);
    });
  }

  function bindEvents(form) {
    if (!form || form.dataset.amourSwatchBound === 'true') {
      return;
    }

    form.dataset.amourSwatchBound = 'true';

    form.addEventListener('change', function(event) {
      var sizeSelect = event.target.closest('[data-size-select]');

      if (sizeSelect) {
        var swatch = sizeSelect.closest('.swatch');
        var radio = Array.prototype.slice.call(swatch.querySelectorAll('input[type="radio"]')).find(function(item) {
          return item.value === sizeSelect.value && !item.disabled;
        });

        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        saveSelectionState(form, 'selection');
        return;
      }

      if (event.target.matches('#product-variants .swatch input[type="radio"]')) {
        syncSizeSelects(form);
        saveSelectionState(form, 'selection');
      }
    });

    form.addEventListener('click', function(event) {
      var sizeChartTrigger = event.target.closest('[data-size-chart-trigger]');
      var linkedOption = event.target.closest('.amour-linked-option');

      if (sizeChartTrigger) {
        if (sizeChartTrigger.closest('[data-ovale-pdp]')) {
          return;
        }
        event.preventDefault();
        rememberKiwiScrollPosition(window.scrollY);
        openKiwiCustomModal(sizeChartTrigger);
        return;
      }

      if (!linkedOption) {
        return;
      }

      event.preventDefault();
      saveSelectionState(form, 'linked-navigation');
      window.location.href = linkedOption.href;
    });
  }

  function init() {
    var form = getForm();

    getSizeChartConfig();
    bindKiwiModalObserver();

    if (!form) {
      return;
    }

    bindEvents(form);
    syncSizeSelects(form);
    hideStandaloneSizeChart(form);

    fetchGroups().then(function(data) {
      if (!data) {
        return;
      }

      buildLinkedSwatches(form, data);
      applySavedSelections(form);
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('amour:variant:change', function(event) {
    var form = event.detail && event.detail.form ? event.detail.form : getForm();

    if (!form) {
      return;
    }

    syncSizeSelects(form);
    hideStandaloneSizeChart(form);
  });
})();
